import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import CopierCostWrapper from "@components/layouts/copierCostsWrapper";

import { getPageProps } from "@services/initial-calls";
import PrivacyPolicy from "@components/shared/legal/privacyPolicy";

export default function CopierCostHome(): ReactElement {
    return (
        <CopierCostWrapper>
            <PrivacyPolicy
                category="Digital Copiers"
                domain="CopierCosts.com"
            />
        </CopierCostWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Privacy Policy" });
};
